function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1060.613 -2704.776)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1117.445,2753.5H1109.2a.506.506,0,0,1-.505-.505v-41.833a.506.506,0,0,1,.505-.5h8.242a.5.5,0,0,1,.505.5v41.833A.5.5,0,0,1,1117.445,2753.5Zm-7.737-1.011h7.231v-40.821h-7.231Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1106.456,2753.5h-8.243a.506.506,0,0,1-.506-.505v-36.646a.506.506,0,0,1,.506-.5h8.243a.5.5,0,0,1,.505.5v36.646A.505.505,0,0,1,1106.456,2753.5Zm-7.738-1.011h7.232v-35.634h-7.232Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1095.465,2753.5h-8.243a.5.5,0,0,1-.505-.505v-31.606a.5.5,0,0,1,.505-.505h8.243a.5.5,0,0,1,.505.505v31.606A.5.5,0,0,1,1095.465,2753.5Zm-7.738-1.011h7.233v-30.594h-7.233Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1084.475,2753.5h-8.244a.505.505,0,0,1-.505-.505v-24.582a.506.506,0,0,1,.505-.5h8.244a.506.506,0,0,1,.505.5v24.582A.506.506,0,0,1,1084.475,2753.5Zm-7.739-1.011h7.233v-23.571h-7.233Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1073.483,2753.5h-8.244a.5.5,0,0,1-.505-.505v-17.257a.5.5,0,0,1,.505-.5h8.244a.5.5,0,0,1,.505.5v17.257A.505.505,0,0,1,1073.483,2753.5Zm-7.739-1.011h7.234v-16.247h-7.234Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1121.568,2756.089h-60.449a.505.505,0,1,1,0-1.01h60.449a.505.505,0,1,1,0,1.01Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.557,2729.6a.5.5,0,0,1-.17-.98c.269-.1,27.188-9.889,39.019-23.672a.5.5,0,1,1,.766.657c-12,13.987-39.171,23.868-39.444,23.965A.49.49,0,0,1,1063.557,2729.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1102.649,2711.912h0a.506.506,0,0,1-.5-.506l.005-5.455-5.154.023h0a.505.505,0,0,1,0-1.01l5.663-.026a.505.505,0,0,1,.508.505l-.006,5.963A.507.507,0,0,1,1102.649,2711.912Z"
}));

var SvgPartner3 = function SvgPartner3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.46,
    height: 51.313,
    viewBox: "0 0 61.46 51.313",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner3.63aecf7d.svg";
export { ForwardRef as ReactComponent };